import { TaskTableColumn, ColumnDefinition } from './types';

/**
 * Column definitions with display properties
 */
export const COLUMN_DEFINITIONS: Record<TaskTableColumn, ColumnDefinition> = {
  [TaskTableColumn.SELECT]: {
    id: 'select',
    label: '',
    width: 48,
    align: 'center',
    sortable: false,
    mobileVisible: true,
  },
  [TaskTableColumn.CHECKBOX]: {
    id: 'checkbox',
    label: '',
    width: 48,
    align: 'center',
    sortable: false,
    mobileVisible: true,
  },
  [TaskTableColumn.TASK]: {
    id: 'task',
    label: 'Task',
    width: 'auto',
    align: 'left',
    sortable: true,
    mobileVisible: true,
  },
  [TaskTableColumn.CATEGORY]: {
    id: 'category',
    label: 'Category',
    width: 120,
    align: 'left',
    sortable: true,
    mobileVisible: true,
  },
  [TaskTableColumn.ISSUE_TYPE]: {
    id: 'issueType',
    label: 'Type',
    width: 80,
    align: 'left',
    sortable: true,
    mobileVisible: false,
  },
  [TaskTableColumn.PRIORITY]: {
    id: 'priority',
    label: 'Priority',
    width: 100,
    align: 'left',
    sortable: true,
    mobileVisible: true,
  },
  [TaskTableColumn.STATUS]: {
    id: 'status',
    label: 'Status',
    width: 120,
    align: 'left',
    sortable: true,
    mobileVisible: true,
  },
  [TaskTableColumn.LINKS]: {
    id: 'links',
    label: 'Links',
    width: 80,
    align: 'center',
    sortable: false,
    mobileVisible: true,
  },
  [TaskTableColumn.CREATED_AT]: {
    id: 'createdAt',
    label: 'Created At',
    width: 120,
    align: 'left',
    sortable: true,
    mobileVisible: false,
  },
  [TaskTableColumn.START_DATE]: {
    id: 'startDate',
    label: 'Start Date',
    width: 100,
    align: 'left',
    sortable: true,
    mobileVisible: false,
  },
  [TaskTableColumn.DUE_DATE]: {
    id: 'dueDate',
    label: 'Due Date',
    width: 140,
    align: 'left',
    sortable: true,
    mobileVisible: true,
  },
  [TaskTableColumn.COMPLETED_AT]: {
    id: 'completedAt',
    label: 'Completed At',
    width: 150,
    align: 'left',
    sortable: true,
    mobileVisible: false,
  },
  [TaskTableColumn.RACI]: {
    id: 'raci',
    label: 'Role',
    width: 80,
    align: 'center',
    sortable: false,
    mobileVisible: true,
  },
  [TaskTableColumn.ASSIGNED]: {
    id: 'assigned',
    label: 'Assigned',
    width: 120,
    align: 'left',
    sortable: false,
    mobileVisible: true,
  },
  [TaskTableColumn.ACTIONS]: {
    id: 'actions',
    label: '',
    width: 100,
    align: 'right',
    sortable: false,
    mobileVisible: true,
  },
};
